import React from "react";

const nfPKR = new Intl.NumberFormat("en-PK", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const nfMetal = new Intl.NumberFormat("en-PK", {
  minimumFractionDigits: 3,
  maximumFractionDigits: 3,
});

const PartnerProfileModal = ({ show, onClose, partner }) => {
  if (!show || !partner) return null;

  const { name, contact, cnic, address, profitRatio, ownershipType, totals } =
    partner;

  const rows = [
    { label: "Name", value: name },
    { label: "Contact", value: contact || "-" },
    { label: "CNIC", value: cnic || "-" },
    { label: "Address", value: address || "-" },
    {
      label: "Profit Ratio",
      value: `${profitRatio ? `${profitRatio}%` : "-"}`,
    },
    { label: "Ownership", value: ownershipType },
  ];

  const totalsRows = [
    { label: "Gold", value: `${nfMetal.format(totals?.goldGram ?? 0)} g` },
    {
      label: "Silver",
      value: `${nfMetal.format(totals?.silverGram ?? 0)} g`,
    },
    { label: "Cash", value: `PKR ${nfPKR.format(totals?.cashPKR ?? 0)}` },
    { label: "Total (PKR)", value: nfPKR.format(totals?.totalPKR ?? 0) },
    { label: "Contributions", value: totals?.contributions ?? 0 },
  ];

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.5)",
          zIndex: 1040,
        }}
      />

      {/* Dialog */}
      <div
        role="dialog"
        aria-labelledby="partnerProfileTitle"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
          background: "#fff",
          borderRadius: "16px",
          padding: "2rem 2.5rem",
          width: "min(480px, 95vw)",
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
        }}
      >
        {/* Title */}
        <h2
          id="partnerProfileTitle"
          style={{
            textAlign: "center",
            fontWeight: 700,
            fontSize: "1.75rem",
            color: "#3d3d3d",
            marginBottom: "1.5rem",
          }}
        >
          Partner Profile
        </h2>

        {/* Personal Info */}
        <div style={{ textAlign: "left" }}>
          {rows.map(({ label, value }) => (
            <p
              key={label}
              style={{ margin: "0.4rem 0", fontSize: "0.95rem", color: "#333" }}
            >
              <strong>{label}:</strong> {value}
            </p>
          ))}
        </div>

        <hr style={{ margin: "1rem 0", borderColor: "#e0e0e0" }} />

        {/* Totals */}
        <div style={{ textAlign: "left" }}>
          {totalsRows.map(({ label, value }) => (
            <p
              key={label}
              style={{ margin: "0.4rem 0", fontSize: "0.95rem", color: "#333" }}
            >
              <strong>{label}:</strong> {value}
            </p>
          ))}
        </div>

        {/* Close Button */}
        <div style={{ textAlign: "center", marginTop: "1.75rem" }}>
          <button
            onClick={onClose}
            style={{
              background: "#7c6fcd",
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              padding: "10px 32px",
              fontSize: "1rem",
              fontWeight: 600,
              cursor: "pointer",
              transition: "background 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#6a5fc1")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#7c6fcd")}
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default PartnerProfileModal;
